import React, { useEffect, useContext } from 'react';
import { StateContext } from '../../../state/index';

export const AutoLoginFlow = ({ recipientLogin, children }) => {
  const [{ selectedPaymentNetwork }] = useContext(StateContext);
  useEffect(() => {
    const login = async () => {
      try {
        const dataForRecipientLogin = {
          payment_network: selectedPaymentNetwork,
        };

        await recipientLogin({ dataForRecipientLogin });
      } catch (error) {
        console.log(error);
      }
    };

    login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{children}</>;
};

export default AutoLoginFlow;
